import { connect } from 'react-redux'
import CurrentProjects from '../../components/projects/CurrentProjects'
import * as groupActions from '../../actions/group'
import * as disciplineActions from '../../actions/discipline'
import * as performanceActions from '../../actions/performance'
import * as currentPerformanceActions from '../../actions/currentPerformance'
import { educationYear } from "../../actions/schedule"
import { getGroupNew } from "../../actions/management"
import { getStudents_student_projects_teacher } from '../../actions/report'


const mapStateToProps = ({
  auth: { isTeacher, mid },
  currentPerformance: { studentProjects, selectedProject, modalWindow, students },
  discipline,
  group,
  performance,
  schedule: { educationYear },
  lk: { data: { yeducationyearid } },
  management,
  report,
}) => ({
  years: group.years,
  // groups: group.list,
  disciplines: discipline.disciplines,
  disciplinesByTerm: discipline.disciplinesByTerm,
  disciplinesByTerms: discipline.disciplinesByTerms,
  terms: performance.terms,
  studentProjects,
  modalData: modalWindow.data,
  selectedProject,
  students,
  isTeacher,
  mid,
  coursesList: educationYear,
  course: yeducationyearid,
  group: management.group, // группы с годом и семестром
  studentList: report.students_list, // группы с годом и семестром


})

const mapDispatchToProps = dispatch => ({
  fetchGroupList: () => dispatch(groupActions.getGroupList()),
  fetchStudentProjects: (cId, termId, isTeacher, studentId, groupId) =>
    dispatch(currentPerformanceActions.studentProjects(cId, termId, isTeacher, studentId, groupId)),
  fetchStudentProject: projectId => dispatch(currentPerformanceActions.studentProject(projectId)),
  fetchStudents: (page, group) => dispatch(currentPerformanceActions.students(page, group)),
  fetchAllDisciplines: () => dispatch(disciplineActions.allDisciplines()),
  fetchDisciplinesByTerm: (termId) => dispatch(disciplineActions.disciplinesByTerm(termId)),
  fetchDisciplinesByParams: (params) => dispatch(disciplineActions.fetchDisciplinesByParams(params)),
  fetchYears: () => dispatch(groupActions.schoolYear()),
  fetchTerms: yearId => dispatch(performanceActions.terms(yearId)),
  fetchFiles: (sheId, instance, type, typeOfWork) => dispatch(currentPerformanceActions.files(sheId, instance, type, typeOfWork)),

  uploadFile: (file, type, projectId) => dispatch(currentPerformanceActions.uploadStudentFile(file, type, projectId)),
  uploadReviewFile: (projectId, reviewId, file) =>
    dispatch(currentPerformanceActions.uploadStudentReviewFile(projectId, reviewId, file)),
  deleteFile: (projectId, type, name) => dispatch(currentPerformanceActions.deleteStudentFile(projectId, type, name)),
  downloadFile: (filename, type, projectId) => dispatch(currentPerformanceActions.downloadStudentFile(filename, type, projectId)),
  updateStudentWork: (projectId, values) => dispatch(currentPerformanceActions.updateStudentWork(projectId, values)),
  addReview: (projectId, values, files) => dispatch(currentPerformanceActions.addReview(projectId, values, files)),
  removeReview: (projectId, reviewId) => dispatch(currentPerformanceActions.removeReview(projectId, reviewId)),
  editReview: (projectId, reviewId, values) => dispatch(currentPerformanceActions.editReview(projectId, reviewId, values)),
  removeReviewFile: (projectId, reviewId, name) =>
    dispatch(currentPerformanceActions.removeReviewFile(projectId, reviewId, name)),
  addProject: (values, files) => dispatch(currentPerformanceActions.addProject(values, files)),
  clearProject: () => dispatch(currentPerformanceActions.clearProject()),
  getCoursesList: () => dispatch(educationYear()),

  getGroupList: (year, term) => dispatch(getGroupNew(year, '', term)),  // группа от года и семестра
  getStudentsList: (params) => dispatch(getStudents_student_projects_teacher(params))  // группа от года и семестра(от до )
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CurrentProjects)
